import { get } from "../../../utils/object-helpers";

$ {
    const text = get(input, "text", {});
    const status = get(input, "status", "neutral");
}

<ebay-signal status=status>
    <str-textual-display ...text />
</ebay-signal>
